export function PaymentRows({
  rows,
  empty,
}: {
  rows: Array<{ id: string; title: string; amount: string; meta: string }>;
  empty: string;
}) {
  if (!rows.length) return <div className="tool-empty">{empty}</div>;

  return (
    <div className="tool-list">
      {rows.map((row) => (
        <div className="tool-row" key={row.id}>
          <div className="tool-row-main">
            <div className="tool-row-title">{row.title}</div>
            <div className="tool-row-sub">{row.meta}</div>
          </div>
          <span className="tool-pill neutral">{row.amount}</span>
        </div>
      ))}
    </div>
  );
}
